<template>
  <path d="M12 0c-4.87 7.197-8 11.699-8 16.075 0 4.378 3.579 7.925 8 7.925s8-3.547 8-7.925c0-4.376-3.13-8.878-8-16.075z"/>
</template>

<script>
export default {
  name: 'IconWater'
}
</script>



// WEBPACK FOOTER //
// src/components/icons/IconWater.vue